export const MAX_FLEET_NAME_LENGTH = 32;
